/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Jayd Saucedo <jayd@sauce.do>
 * Date: 1/11/18
 * Copyright All Rights Reserved
 */
import { noop } from 'lodash/fp';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from 'support/config';
import apiBaseUrl from 'support/apiBaseUrl';

const fileDownload = require('react-file-download');
const axios = require('axios');

const sanitizeFilename = (name) => {
  const sanitized = name
    .replace(/[/\\:*?"<>|]/g, '_')
    .replace(/\0/g, '')
    .trim();
  return sanitized || 'report'; // fallback prevents '.pdf' if name is empty or composed entirely of stripped characters
};

class ReportLink extends Component {
  constructor(props) {
    super(props);

    this.url = apiBaseUrl(config);

    this.defaultOptions = {
      url: '',
      headers: {
        Authorization: `bearer ${this.props.token}`,
        'Content-Type': 'application/json',
      },
      method: 'get',
    };

    this.handleReportClick.bind(this);
  }

  handleReportClick(e) {
    e.preventDefault();
    const options = Object.assign({}, this.defaultOptions, {
      url: `${this.url}/reports/${this.props.url}`,
      responseType: 'arraybuffer',
    });

    let isLoading = true;
    this.props.loadingEventHandler(isLoading);

    axios(options)
      .then((res) => {
        fileDownload(res.data, `${sanitizeFilename(this.props.name)}.pdf`);
        isLoading = false;
        this.props.loadingEventHandler(isLoading);
      })
      .catch(() => {
        isLoading = false;
        this.props.loadingEventHandler(isLoading);
      });
  }

  render() {
    const { children, disabled, id } = this.props;
    const onClick = disabled
      ? noop
      : (e) => { this.handleReportClick(e); };
    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      <a
        key={id}
        onClick={onClick}
        className="report-link"
      >
        {children}
      </a>
      /* eslint-enable jsx-a11y/no-static-element-interactions */
    );
  }
}

ReportLink.defaultProps = {
  children: 'Download Report',
  disabled: false,
};

ReportLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
  disabled: PropTypes.bool,
  loadingEventHandler: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  token: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default ReportLink;
